/**
 * Release notes — single source of truth for desktop "What's New".
 *
 * `release-notes.json` (repo root) is bundled into the app (used by
 * WhatsNewModal after an update relaunch) AND published to
 * widgets.weavein.ai/downloads/release-notes.json by CI, so the *previous*
 * version's update banner can show the incoming version's notes at download
 * time (the old bundle doesn't have the new version's notes baked in).
 */
import notesData from '@/release-notes.json';

export interface ReleaseNote {
  date?: string;
  title?: string;
  items: string[];
}

export const RELEASE_NOTES = notesData as Record<string, ReleaseNote>;

/** Notes for a specific version (tolerates a leading "v"). */
export function getReleaseNotes(version?: string | null): ReleaseNote | null {
  if (!version) return null;
  const v = version.replace(/^v/, '');
  return RELEASE_NOTES[v] ?? null;
}

/** Public URL the update banner fetches to show incoming-version notes. */
export const RELEASE_NOTES_URL =
  'https://widgets.weavein.ai/downloads/release-notes.json';
